import { UserInformationAddress } from '@rover/rsdk/src/apiClient/latest';
import getUserAgentFlags from '@rover/shared/js/utils/getUserAgentFlags';

export const shouldShowCurrentLocation = () => {
  const { isMobile } = getUserAgentFlags();
  return isMobile;
};

export const getSuggestionId = (inputId: string, index?: number): string =>
  index ? `${inputId}-result-${index}` : `${inputId}-result`;

export const formatAddress = (addressToFormat: UserInformationAddress): string => {
  if (!addressToFormat) return '';

  const { addressLine1, city, state, countryCode, zip } = addressToFormat;

  // We don't want to prefill if we only have a zip code.
  const meaningfulParts = [addressLine1, city, state].filter(Boolean);
  if (meaningfulParts.length === 0) {
    return '';
  }

  const parts = [addressLine1, city, state, zip, countryCode].filter(Boolean);
  return parts.join(', ');
};
